import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import { SocketService } from '../../../../socket.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-saturation-actuator',
  templateUrl: './saturation-actuator.component.html',
  styleUrls: ['./saturation-actuator.component.scss']
})
export class SaturationActuatorComponent implements OnInit, OnDestroy {
  @Input() endpoint: any;
  /**
   * Current node, parent of the endpoint.
   */
  @Input() private node: any;
  @Output() private endpointChange: EventEmitter<any> = new EventEmitter();
  @Input() public status: boolean;
  public data: any;
  private ioConnectionActuation$: Subscription;

  public constructor(private socketService: SocketService) { }

  public ngOnInit() {
    this.data = { ...this.endpoint };
    if (!this.data.current) {
      this.data.current = 0;
    }

    this.ioConnectionActuation$ = this.socketService
      .onMeasureCreated()
      .subscribe((measure: any) => {
        if (this.node._id === measure.device && this.data._id === measure.endpoint)
        {
          return this.updateMeasure(measure);
        }
        return;
      });
  }

  updateMeasure(measure: any) {
    this.data.current = measure.value;
  }

  public onChangeDimmer(value: any) {
    this.data.current = value;
    console.log('dimmer', value);
    this.endpointChange.emit({
      updated: true,
      _id: this.data._id,
      value: this.data.current
    });
  }

  public ngOnDestroy() {
    if (this.ioConnectionActuation$) {
      this.ioConnectionActuation$.unsubscribe();
    }
  }
}
